import { createReducerUsingActionHandlers, ERROR, PENDING, SUCCESS } from '@travel-frontend/state-handling-sdk';
import { createSelector } from 'reselect';
import { SERVICE_CONFIG } from '../../../components/HeaderNew/redux/actions.js';
import { serviceConfig } from '../../../components/HeaderNew/redux/ServiceConfigState.js';
const initialState = {};
const actionCreators = {
  [PENDING(SERVICE_CONFIG)]: state => ({
    ...state,
    loading: true
  }),
  [SUCCESS(SERVICE_CONFIG)]: (state, action) => ({
    ...state,
    loading: false,
    data: action.data
  }),
  [ERROR(SERVICE_CONFIG)]: (state, action) => ({
    ...state,
    loading: false,
    error: action.error.toJSON().message
  })
};
export const serviceConfigReducer = createReducerUsingActionHandlers(initialState, actionCreators);
const isServiceConfigLoaded = createSelector(serviceConfig, state => !state.loading && state.data !== undefined);
export const getServiceConfigData = createSelector([serviceConfig, isServiceConfigLoaded], (state, loaded) => loaded && state.data ? state.data : null);